(function () {
  const bar = document.querySelector("[data-sticky-atc]");
  if (!bar) return;

  const qtyDecreaseBtn = bar.querySelector("[data-sticky-atc-qty-decrease]");
  const qtyIncreaseBtn = bar.querySelector("[data-sticky-atc-qty-increase]");
  const qtyValueEl = bar.querySelector("[data-sticky-atc-qty-value]");
  const submitBtn = bar.querySelector("[data-sticky-atc-submit]");
  const submitTextEl = bar.querySelector("[data-sticky-atc-submit-text]");
  const variantSelectEl = bar.querySelector("[data-sticky-atc-variant-select]");
  const weightEl = bar.querySelector("[data-sticky-atc-weight]");
  const customSelectEl = bar.querySelector("[data-sticky-atc-custom-select]");
  const customTrigger = customSelectEl
    ? customSelectEl.querySelector("[data-sticky-atc-custom-trigger]")
    : null;
  const customPanel = customSelectEl
    ? customSelectEl.querySelector("[data-sticky-atc-custom-panel]")
    : null;
  const customThumb = customSelectEl
    ? customSelectEl.querySelector("[data-sticky-atc-custom-thumb]")
    : null;
  const customLabel = customSelectEl
    ? customSelectEl.querySelector("[data-sticky-atc-custom-label]")
    : null;

  if (!qtyValueEl || !submitBtn || !submitTextEl) return;

  const translations = {
    adding: bar.getAttribute("data-t-adding") || "...",
    added: bar.getAttribute("data-t-added") || "✓",
    error: bar.getAttribute("data-t-error") || "Error",
    soldOut: bar.getAttribute("data-t-sold-out") || "Sold out",
  };
  const addToCartText = submitTextEl.textContent.trim();

  let quantity = 1;
  let isVisible = false;

  /* ── Utilities ───────────────────────────────────────────── */

  function getSelectedVariantOption() {
    if (!variantSelectEl) return null;
    return variantSelectEl.options[variantSelectEl.selectedIndex];
  }

  function syncStickyCustomUI(variantId) {
    if (!customPanel) return;
    const id = String(variantId);
    const optBtns = customPanel.querySelectorAll("[data-sticky-atc-custom-option]");

    optBtns.forEach((btn) => {
      const isSelected = btn.getAttribute("data-sticky-atc-custom-option") === id;
      btn.setAttribute("aria-selected", String(isSelected));
      btn.classList.toggle("bg-gray-light", isSelected);
      btn.classList.toggle("font-bold", isSelected);

      if (isSelected) {
        const labelSpan = btn.querySelector(":scope > span:last-child");
        if (customLabel && labelSpan) customLabel.textContent = labelSpan.textContent;
        if (customThumb) {
          const img = btn.querySelector("img");
          const flavorColor = btn.getAttribute("data-flavor-color");
          customThumb.innerHTML = "";
          if (img) {
            const cloned = img.cloneNode();
            cloned.className = "w-full h-full object-cover";
            customThumb.appendChild(cloned);
            if (flavorColor) {
              const overlay = document.createElement("span");
              overlay.className = "absolute inset-0 mix-blend-overlay opacity-80";
              overlay.style.background = flavorColor;
              customThumb.appendChild(overlay);
            }
          } else if (flavorColor) {
            const overlay = document.createElement("span");
            overlay.className = "absolute inset-0";
            overlay.style.background = flavorColor;
            customThumb.appendChild(overlay);
          }
        }
      }
    });
  }

  function initStickyCustomSelect() {
    if (!customTrigger || !customPanel) return;

    function openPanel() {
      customPanel.classList.remove("hidden");
      customTrigger.setAttribute("aria-expanded", "true");
    }

    function closePanel() {
      customPanel.classList.add("hidden");
      customTrigger.setAttribute("aria-expanded", "false");
    }

    customTrigger.addEventListener("click", (e) => {
      e.stopPropagation();
      if (customPanel.classList.contains("hidden")) {
        openPanel();
      } else {
        closePanel();
      }
    });

    customPanel.addEventListener("click", (e) => {
      e.stopPropagation();
      const optBtn = e.target.closest("[data-sticky-atc-custom-option]");
      if (!optBtn) return;
      const variantId = optBtn.getAttribute("data-sticky-atc-custom-option");
      if (variantSelectEl) {
        variantSelectEl.value = variantId;
        handleVariantChange();
      }
      syncStickyCustomUI(variantId);
      closePanel();
      customTrigger.focus();
      document.dispatchEvent(
        new CustomEvent("variant:changed", {
          detail: { variantId: parseInt(variantId, 10), source: "sticky" },
        }),
      );
    });

    customTrigger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (customPanel.classList.contains("hidden")) {
          openPanel();
          const firstOpt = customPanel.querySelector("[data-sticky-atc-custom-option]");
          if (firstOpt) firstOpt.focus();
        } else {
          closePanel();
        }
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        openPanel();
        const firstOpt = customPanel.querySelector("[data-sticky-atc-custom-option]");
        if (firstOpt) firstOpt.focus();
      } else if (e.key === "Escape") {
        closePanel();
      }
    });

    customPanel.addEventListener("keydown", (e) => {
      const opts = Array.from(
        customPanel.querySelectorAll("[data-sticky-atc-custom-option]"),
      );
      const currentIndex = opts.indexOf(document.activeElement);

      if (e.key === "ArrowDown") {
        e.preventDefault();
        opts[(currentIndex + 1) % opts.length].focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        opts[currentIndex <= 0 ? opts.length - 1 : currentIndex - 1].focus();
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (
          document.activeElement &&
          document.activeElement.hasAttribute("data-sticky-atc-custom-option")
        ) {
          document.activeElement.click();
        }
      } else if (e.key === "Escape") {
        closePanel();
        customTrigger.focus();
      } else if (e.key === "Tab") {
        closePanel();
      }
    });

    document.addEventListener("click", () => closePanel());
  }

  /* ── Visibility (IntersectionObserver) ───────────────────── */

  function showBar() {
    if (isVisible) return;
    isVisible = true;
    bar.classList.remove("translate-y-full");
    bar.classList.add("translate-y-0");
  }

  function hideBar() {
    if (!isVisible) return;
    isVisible = false;
    bar.classList.remove("translate-y-0");
    bar.classList.add("translate-y-full");
  }

  const productSection = document.querySelector(".main-product-section");
  if (productSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hideBar();
          } else {
            showBar();
          }
        });
      },
      { rootMargin: "0px", threshold: 0 },
    );
    observer.observe(productSection);
  }

  /* ── Variant change ──────────────────────────────────────── */

  function handleVariantChange() {
    const option = getSelectedVariantOption();
    if (!option) return;

    const variantId = option.value;
    const available = option.getAttribute("data-available") === "true";
    const weight = option.getAttribute("data-weight");

    submitBtn.setAttribute("data-variant-id", variantId);
    submitBtn.disabled = !available;
    submitTextEl.textContent = available ? addToCartText : translations.soldOut;

    if (weightEl && weight) {
      weightEl.textContent = weight;
    }
  }

  if (variantSelectEl) {
    variantSelectEl.addEventListener("change", () => {
      handleVariantChange();
      const option = getSelectedVariantOption();
      if (option) {
        document.dispatchEvent(
          new CustomEvent("variant:changed", {
            detail: { variantId: parseInt(option.value, 10), source: "sticky" },
          }),
        );
      }
    });
  }

  /* ── Sync with buy box variant changes ───────────────────── */

  document.addEventListener("variant:changed", (event) => {
    const detail = event.detail || {};
    const { variantId } = detail;
    if (!variantId || detail.source === "sticky") return;

    if (variantSelectEl) {
      variantSelectEl.value = String(variantId);
      handleVariantChange();
    } else {
      submitBtn.setAttribute("data-variant-id", String(variantId));
    }
    syncStickyCustomUI(variantId);
  });

  /* ── Quantity controls ───────────────────────────────────── */

  function updateStickyQtyDisplay() {
    qtyValueEl.textContent = quantity;
    if (qtyDecreaseBtn) qtyDecreaseBtn.disabled = quantity <= 1;
  }

  if (qtyDecreaseBtn) {
    qtyDecreaseBtn.addEventListener("click", () => {
      if (quantity > 1) {
        quantity -= 1;
        updateStickyQtyDisplay();
        document.dispatchEvent(
          new CustomEvent("quantity:changed", {
            detail: { quantity, source: "sticky" },
          }),
        );
      }
    });
  }

  if (qtyIncreaseBtn) {
    qtyIncreaseBtn.addEventListener("click", () => {
      quantity += 1;
      updateStickyQtyDisplay();
      document.dispatchEvent(
        new CustomEvent("quantity:changed", {
          detail: { quantity, source: "sticky" },
        }),
      );
    });
  }

  /* ── Sync with buy box quantity changes ──────────────────── */

  document.addEventListener("quantity:changed", (event) => {
    const detail = event.detail || {};
    if (detail.source !== "buybox") return;
    quantity = detail.quantity;
    updateStickyQtyDisplay();
  });

  /* ── Add to cart ─────────────────────────────────────────── */

  function resetButton() {
    const option = getSelectedVariantOption();
    const available = option
      ? option.getAttribute("data-available") === "true"
      : true;
    submitBtn.disabled = !available;
    submitTextEl.textContent = available ? addToCartText : translations.soldOut;
  }

  function addToCart() {
    const variantId = submitBtn.getAttribute("data-variant-id");
    if (!variantId) return;

    submitBtn.disabled = true;
    submitTextEl.textContent = translations.adding;

    fetch(`${window.routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(() => {
        submitTextEl.textContent = translations.added;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:open"));
        setTimeout(resetButton, 1500);
      })
      .catch(() => {
        submitTextEl.textContent = translations.error;
        setTimeout(resetButton, 2000);
      });
  }

  submitBtn.addEventListener("click", addToCart);

  // Initialize
  updateStickyQtyDisplay();
  initStickyCustomSelect();
})();
